// Precarga de la ficha de al lado (Anterior/Siguiente) para que el cambio de candidato sea inmediato.
// Regla: lo precargado solo sirve para PINTAR rápido; la ficha SIEMPRE vuelve a pedir la versión fresca a la
// API y la reemplaza (así nunca se queda una nota, etapa o motivo viejo en pantalla). Toda escritura sobre un
// candidato borra su precarga.
import type { FichaPortal, PortalApi } from "./api";

type Entrada = { t: number; p: Promise<FichaPortal>; v?: FichaPortal };
const VIGENCIA_MS = 60_000;
const fichas = new Map<string, Entrada>();

/** Pide la ficha en segundo plano (y la liga del CV) si no hay una reciente. */
export function precargarFicha(api: PortalApi, id: string) {
  const e = fichas.get(id);
  if (e && Date.now() - e.t < VIGENCIA_MS) return;
  const nueva: Entrada = { t: Date.now(), p: api.candidato(id) };
  nueva.p
    .then((f) => {
      nueva.v = f;
      if (!f.bloqueado && f.cv_url) void precalentarCv(api, f.cv_url);
    })
    .catch(() => {
      if (fichas.get(id) === nueva) fichas.delete(id);
    });
  fichas.set(id, nueva);
}

/** Lo precargado de `id`, ya resuelto (para pintar en el primer cuadro); null si no hay o ya venció. */
export function fichaPrecargada(id: string): FichaPortal | null {
  const e = fichas.get(id);
  if (!e || Date.now() - e.t >= VIGENCIA_MS) return null;
  return e.v ?? null;
}

/** Tras cualquier escritura sobre el candidato (etapa, descarte, nota) o al recibir su versión fresca. */
export function olvidarFicha(id: string) {
  fichas.delete(id);
}

/**
 * Deja lista la liga del CV y calienta la caché del navegador con el archivo, para que el visor lo abra
 * al instante. Solo ligas https (en modo demo son blob: de un solo uso y ya son inmediatas).
 */
const calentados = new Set<string>();
export async function precalentarCv(api: PortalApi, cvUrl: string) {
  if (api.modo !== "supabase") return;
  try {
    const u = await api.urlCv(cvUrl);
    if (!u || !/^https:\/\//.test(u) || calentados.has(u)) return;
    calentados.add(u);
    await fetch(u, { mode: "no-cors", credentials: "omit", priority: "low" } as RequestInit);
  } catch {
    /* es solo para ir más rápido: si falla, el visor lo pide normal */
  }
}
